export default function UserBasicInformation({
  openModal,
  basicInformation,
  countries,
  states,
  cities,
  genders,
  experiences,
  experienceLevels,
  martialStatuses,
  degrees,
  lang,
  onExport,
}: any) {
  const data = basicInformation?.[0];

  const country = countries?.find(
    (loc: any) => loc.id === data?.country
  );

  const state = states?.find(
    (loc: any) => loc.id === data?.state
  );

  const city = cities?.find(
    (loc: any) => loc.id === data?.city
  );

  const genderLabel = genders?.find(
    (gen: any) => gen.id === data?.gender
  )?.name;

  const degreeLabel = degrees?.find(
    (deg: any) => deg.id === data?.degree
  )?.name;

  const expYear = experiences?.find(
    (exp: any) => exp.id === data?.experience
  )?.name;

  const expLevel = experienceLevels?.find(
    (exp: any) => exp.id === data?.experienceLevel
  )?.name;

  const martialStatusLabel = martialStatuses?.find(
    (gen: any) => gen.id === data?.martialStatus
  )?.name;

  const formatDate = (date?: string) => {
    if (!date) return "-";
    return new Date(date).toISOString().slice(0, 10);
  };

  return (
    <div className="bg-white rounded-2xl p-6 shadow space-y-6">
        
        <h3 className="text-lg font-semibold">{lang === "id" ? "Informasi Umum" : "Basic Information"} <span className="text-red-500">*</span></h3>

      {/* ===== HEADER ===== */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center gap-4">
          {/* Avatar */}
          <div className="md:w-20 w-28 h-20 rounded-full bg-primary/10 overflow-hidden">
            <img
              src={data?.imgProfile}
              alt={data?.name}
              className="w-full h-full object-cover"
            />
          </div>

          {/* Name */}
          <div>
            <h2 className="text-2xl font-bold">
              {data?.name || "-"}
            </h2>

            <p className="text-gray-800">
              {country?.name || "-"}, {state?.name || "-"}, {city?.name || "-"}
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-3">
          <button
            onClick={onExport}
            className="bg-primary text-white text-sm font-medium px-4 py-2 rounded-lg hover:opacity-90 transition"
          >
            Create CV
          </button>

          <button
            onClick={() => openModal("basic")}
            className="text-primary hover:underline"
          >
            ✎ Edit
          </button>
        </div>
      </div>

      {/* ===== CONTENT ===== */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm">
        <div>
          <p className="font-medium text-gray-500">
            {lang === "id" ? "Tanggal Lahir" : "Birth Date"}
          </p>
          <p className="text-gray-800">
            {formatDate(data?.birth)}
          </p>

        </div>

        <div>
          <p className="font-medium text-gray-500">
            {lang === "id" ? "Jenis Kelamin" : "Gender"}
          </p>
          <p className="text-gray-800">{genderLabel || "-"}</p>
        </div>

        <div>
          <p className="font-medium text-gray-500">
            {lang === "id" ? "Status Pernikahan" : "Martial Status"}
          </p>
          <p className="text-gray-800">{martialStatusLabel || "-"}</p>
        </div>

        <div>
          <p className="font-medium text-gray-500">
            {lang === "id" ? "Gelar" : "Degree"}
          </p>
          <p className="text-gray-800">{degreeLabel || "-"}</p>
        </div>

        <div>
          <p className="font-medium text-gray-500">
            {lang === "id" ? "Tahun Pengelaman" : "Experience Year"}
          </p>
          <p className="text-gray-800">{expYear || "-"}</p>
        </div>

        <div>
          <p className="font-medium text-gray-500">
            {lang === "id" ? "Tingkat Pengalaman" : "Experience Level"}
          </p>
          <p className="text-gray-800">{expLevel || "-"}</p>
        </div>

        <div>
          <p className="font-medium text-gray-500">
            {lang === "id" ? "Nomor Telepon" : "Phone Number"}
          </p>
          <p className="text-gray-800">{data?.phone || "-"}</p>
        </div>


        <div className="md:col-span-2">
          <p className="font-medium text-gray-500">
            {lang === "id" ? "Tentang Saya" : "About Me"}
          </p>
          <p className="text-gray-800">{data?.about || "-"}</p>
        </div>
      </div>
    </div>
  );
}
